module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"loadingTitle":"Caricamento domande","loadingSubtitle":"L\u0027operazione dovrebbe richiedere qualche secondo"}}')
  delete Component.options._Ctor
}
